<template>
  <app-loading v-if="loading"></app-loading>
  <section v-else :class="['login', darkMode ? 'dark' : 'light']">
    <div class="wrapper-login">
      <button
        class="btn-theme-toggle"
        @click="toggleDarkMode"
        :title="darkMode ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'"
      >
        <svg
          v-if="darkMode"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M12 3v2.25m6.364.386-1.591 1.591M21 12h-2.25m-.386 6.364-1.591-1.591M12 18.75V21m-4.773-4.227-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0z"
          />
        </svg>
        <svg
          v-else
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M21.752 15.002A9.72 9.72 0 0 1 18 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 0 0 3 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 0 0 9.002-5.998z"
          />
        </svg>
      </button>
      <span class="bubble" v-for="n in 30" :key="n"></span>
      <div class="content-wrapper">
        <form @submit.prevent="doLogin">
          <div class="mb-8">
            <img
              alt="Logo"
              class="w-32 xl:block mx-auto mb-5"
              src="/static/images/LOGO-WHITE-2026.png"
            />
            <div class="fields">
              <label for="">Ingresa tu usuario:</label>
              <div class="box-input-user mt-4 mb-4 intro-x">
                <input
                  type="text"
                  class="input"
                  v-model="user.email"
                  placeholder="Email"
                />
              </div>
              <small class="text-red-600 -mt-2 flex" v-if="errors.email">{{
                errors.email[0]
              }}</small>
              <label for="">Ingresa tu contraseña:</label>
              <div class="box-input-pass mt-2 intro-x">
                <input
                  :type="type"
                  class="input"
                  v-model="user.password"
                  placeholder="Password"
                />
                <div
                  @click="viewPassClick"
                  class="absolute top-0 right-0 rounded-r w-10 h-full flex mr-1 items-center justify-center text-gray-600 cursor-pointer"
                >
                  <svg
                    v-if="!viewPass"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="w-6 h-6"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
                    />
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                  </svg>
                  <svg
                    v-else
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="w-6 h-6"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"
                    />
                  </svg>
                </div>
              </div>
              <small class="text-red-600 mt-2 flex" v-if="errors.password">{{
                errors.password[0]
              }}</small>
            </div>
          </div>
          <div class="intro-x mt-5 text-center">
            <button class="button-login button w-full !text-white">
              Ingresar
            </button>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex'
import Loading from '@/components/admin/partials/Loading'

export default {
  name: 'Login',
  data() {
    return {
      user: {
        email: '',
        password: '',
      },
      viewPass: false,
      type: 'password',
      redirect: '/',
      loading: false,
      errors: [],
      darkMode: true,
    }
  },
  created() {
    // remove localStorage
    delete localStorage.token
    delete localStorage.session_account
    delete localStorage.session_team
    const saved = localStorage.getItem('loginDarkMode')
    this.darkMode = saved !== null ? saved === 'true' : true
  },
  methods: {
    doLogin() {
      var vm = this
      vm.loading = true
      window.$('#login').button('loading')

      vm.login(this.user)
        .then((user) => {
          if (user.role === 1) {
            vm.$router.replace(this.$route.query.redirect || '/admin/dashboard')
          } else {
            if ([2, 3, 5].includes(user.role)) {
              vm.$router.replace(this.$route.query.redirect || '/admin/home')
            } else {
              vm.$router.replace(this.$route.query.redirect || '/admin/home')
            }
          }
        })
        .catch((error) => {
          window.$('#login').button('reset')
          console.log(error)
          if (error.response) {
            let data = error.response.data
            vm.errors = typeof data.errors !== 'undefined' ? data.errors : []
          }
        })
        .finally(() => {
          vm.loading = false
        })
    },
    viewPassClick() {
      this.viewPass = !this.viewPass
      this.type = this.type == 'password' ? 'text' : 'password'
    },
    toggleDarkMode() {
      this.darkMode = !this.darkMode
      localStorage.setItem('loginDarkMode', this.darkMode)
    },
    ...mapActions(['login']),
  },
  components: {
    appLoading: Loading,
  },
}
</script>



// WEBPACK FOOTER //
// Login.vue?c10f4068